// Add a constant for the clean template at the top of the file
export const CLEAN_FORMAT_TEMPLATE = `
<article class="post">
  <header class="entry-header">
    <h1 class="entry-title">Post Title Goes Here</h1>
    <div class="entry-meta">
      <span class="posted-on">Posted on <time class="entry-date">Date</time></span>
      <span class="byline">by <span class="author">Author</span></span>
    </div>
  </header>
  <div class="entry-content">
    <!-- Content will be inserted here -->
  </div>
  <footer class="entry-footer">
    <span class="cat-links">Posted in Categories</span>
    <span class="tags-links">Tagged with Tags</span>
  </footer>
</article>
`;

/**
 * Default WordPress template
 */
export const defaultFormatTemplate = `
  <!-- WordPress Post HTML Structure Example -->
  <article class="post">
    <div class="entry-content">
      <p>First paragraph of the post with an <a href="#">example link</a> goes here.</p>

      <h2>First Subheading</h2>
      <p>
        Content under the first subheading with <strong>bold text</strong> and
        <em>italic text</em>.
      </p>

      <h3>Secondary Subheading</h3>
      <p>More detailed content explaining the topic.</p>

      <ul>
        <li>First bullet point</li>
        <li>Second bullet point</li>
        <li>Third bullet point with <a href="#">link</a></li>
      </ul>

      <h2>Second Main Subheading</h2>
      <p>Opening paragraph for this section introducing the next points.</p>

      <ol>
        <li>First numbered item</li>
        <li>Second numbered item</li>
        <li>Third numbered item</li>
      </ol>

      <blockquote>
        <p>
          This is an example of a blockquote that might contain a testimonial or important
          quote related to the content.
        </p>
      </blockquote>

      <h2>Conclusion</h2>
      <p>Summary paragraph that wraps up the post and may include a call to action.</p>
    </div>
  </article>
`;
